import type { StrictLocaleObject } from '@layers/i18n/shared/locales'
import type { NuxtOptions } from '@nuxt/schema'
import * as locales from '@layers/i18n/shared/locales'
import { en } from '@layers/i18n/shared/locales'

export const i18n: Omit<NuxtOptions['i18n'], 'locales'> & { locales: StrictLocaleObject[] } = {
  locales: Object.values(locales),
  lazy: true,
  langDir: 'locales',
  defaultLocale: en.code,

  strategy: 'prefix',
  trailingSlash: false,

  detectBrowserLanguage: {
    useCookie: true,
    fallbackLocale: en.code,
    cookieKey: 'locale',
  },
}
